module.exports = __webpack_public_path__ + "img/kr.793c8ae2.svg";